import { createFileRoute, Navigate } from "@tanstack/react-router";

function SettingsIndex() {
  const { workspace } = Route.useParams();
  return <Navigate to={`/${workspace}/settings/preferences` as unknown as "/"} />;
}

export const Route = createFileRoute("/(app)/$workspace/settings/")({
  component: SettingsIndex,
});
